import {createIntroHeader} from './scl-intro-header.js?v=2026092511';
import {createArtworkDetail} from './scl-artwork-detail.js?v=2026092201';
import {createGalleryImages} from './scl-gallery-images.js?v=2026092501';
import {observeViewerSize} from './scl-viewer-resize.js?v=2026091424';
import {startup} from './scl-startup.js?v=2026092202';
import {createArtworkTransition} from './scl-artwork-transition.js?v=2026092201';
import {viewerPixelRatio,characterPixelRatio,motionSmoothing,setInteraction} from './scl-interaction.js?v=2026092506';
import {observeArtworkImages,createArtworkDownloads} from './scl-image-loading.js?v=2026091313';
import {createUIEffects} from './scl-ui-effects.js?v=2026092401';
import {artworkUrl,t} from './scl-runtime.js?v=2026091301';
import {createShopifyCart} from './scl-shopify-cart.js?v=2026092203';
import {loadUploadedPhone} from './scl-uploaded-phones.js?v=2026092203';
import {beginModelSelection,prefetchModel,cancelModelPrefetch} from './scl-model-loading.js?v=2026092101';
import {createTurntable} from './scl-turntable.js?v=2026092003';
import {sampleIntro,INTRO_DURATION,phoneFramingRatio,randomIntroIndex,boundedIntroAsset} from './scl-intro-motion.js?v=2026091312';
import {rotationSafeDistance} from './scl-viewer-framing.js?v=2026092601';
import {fitArtworkTexture} from './scl-artwork-placement.js?v=2026092501';
import {animateArchive} from './scl-artwork-motion.js?v=2026091310';
import {createArtworkSearch} from './scl-artwork-search.js?v=2026091312';
import {ARTWORK_NAMES} from './scl-artworks.js?v=2026091301';
import {createArtworkGallery} from './scl-artwork-gallery.js?v=2026092202';
import * as THREE from './scl-three.module.min.js?v=2026091301';
import {finishesFor} from './scl-phone-finishes.js?v=2026091301';
import {DEVICES,DEFAULT_DEVICE,deviceById,shellSpec} from './scl-device-catalog.js?v=2026092101';
import {preserveArtworkColor} from './scl-print-material.js?v=2026091301';
import {buildSnapShell,PRINT_WIDTH,PRINT_HEIGHT} from './scl-snap-geometry.js?v=2026092102';
import {createRandomWallpaper,createScreenWallpaper} from './scl-screen-wallpaper.js?v=2026092003';
import {createViewerGestures} from './scl-viewer-gestures.js?v=2026092516';
import {initViewControls} from './scl-view-controls.js?v=2026092406';
const $=s=>document.querySelector(s), names=ARTWORK_NAMES;
initViewControls(document);
let shopifyCart,characterView,characterLoading=false,characterModuleRequest,characterViewRequest;
const STARTUP_ARTWORK=startup.selectedIndex,STARTUP_WALLPAPER=startup.wallpaperIndex;
const artworkButtons=names.map(()=>[]);
const galleryOrder=[STARTUP_ARTWORK,...names.map((_,i)=>i).filter(i=>i!==STARTUP_ARTWORK)];
let loadArtwork=()=>Promise.resolve(),cancelArtworkLoads=()=>{},showArtworkPreview=()=>false,scheduleNearbyArtworks=()=>{},artworkTransition;
let fastSelection=false,lastSelectionTime=0,selectionLoadTimer=0,wallpaperTimer=0;
const thumbnailImages=new Map();
let thumbnailReady=()=>{};
const retiredTextures=new Set();
function releaseRetiredTextures(){for(const texture of retiredTextures)if(!artworkTransition?.owns(texture)){texture.dispose();retiredTextures.delete(texture)}}
const configurationParams=new URLSearchParams(location.search);
let realPhone,phoneTemplate,currentDevice=DEVICES.find(device=>device.id===configurationParams.get('model'))||deviceById('17'),selectDevice;
let phoneFinish=finishesFor(currentDevice).some(finish=>finish.id===configurationParams.get('finish'))?configurationParams.get('finish'):currentDevice.id==='17'?'lavender':finishesFor(currentDevice)[0].id;
let configurationLoading=false,configurationWallpaper=STARTUP_WALLPAPER;
function publishConfiguration(){
 const finish=finishesFor(currentDevice).find(entry=>entry.id===phoneFinish);
 document.dispatchEvent(new CustomEvent('shejtano:configuration',{detail:{artwork:names[selected],model:currentDevice.id,modelName:currentDevice.name,finish:phoneFinish,finishName:finish?.label||phoneFinish,wallpaper:names[configurationWallpaper],image:artworkUrl(selected,320),loading:configurationLoading}}));
}
document.addEventListener('shejtano:configuration-request',publishConfiguration);
const deviceCache=new Map();
let phone,wallpaper,gestures,baseDistance=10.35,currentZoom=1,updateFraming=()=>{},setViewerQuality=()=>{};
const pose={yaw:0,pitch:0,zoom:1,dragging:false,velocity:0};
const turntable=createTurntable();
const wallpaperIndices=new WeakMap();
let modelPrefetchTimer=0;
function requestModelPrefetch(id){
 clearTimeout(modelPrefetchTimer);
 if(deviceCache.has(id))return;
 modelPrefetchTimer=setTimeout(()=>prefetchModel(deviceById(id)),180);
}
function syncRotationControl(){
 const button=$('#rotate'),label=t(turntable.running?'stop_rotation':'rotate');
 button.setAttribute('aria-pressed',String(turntable.running));button.setAttribute('aria-label',label);button.title=label;
}
function syncScreenDesign(){
 const characterButton=$('#characterView');if(characterButton)characterButton.disabled=!ready||!introFinished||characterLoading;
 const button=$('#useWallpaper');if(!button)return;
 const index=wallpaperIndices.get(phone?.getArtwork());
 const disabled=!ready||!introFinished||!Number.isInteger(index)||index===selected;
 if(button.disabled!==disabled)button.disabled=disabled;
}
function stopTurntable(){
 if(!turntable.running)return;
 turntable.stop();pose.yaw=currentY;syncRotationControl();refresh();
}
let selected=STARTUP_ARTWORK,textures=[],ready=false,mesh,renderer,scene,camera,frame=0,visible=true,velocity=0,dragging=false,lastX=0,lastY=0,targetY=0,targetX=0,currentY=0,currentX=0;
const motionPreference=matchMedia('(prefers-reduced-motion: reduce)');
const reduced=motionPreference.matches;
let characterIdleTimer=0;
function stopIdleTick(){clearTimeout(characterIdleTimer);characterIdleTimer=0}
motionPreference.addEventListener('change',()=>{stopIdleTick();characterView?.resetIdle();if(motionPreference.matches&&!introFinished){introHandAbort?.abort();if(ready)finishIntro();else introSkipRequested=true}refresh()});
const viewer=$('#viewer'),status=$('#viewerStatus');
const skipIntro=reduced||startup.directSelection;
let introTexture=null,introReady=skipIntro,introScheduled=false,introFinished=skipIntro,introElapsed=0,introOffset=0,introPitch=0;
let introHeader=null,introHand=null,introHandAbort=null,introHandRequest=null,introHandLead=0,introHandMounted=false,introSkipRequested=false;
let queuedArtwork=null,queuedDevice=null,pendingWallpaperImage=null,queuedConfiguration=null,configurationRequest=0;
let introIndex=startup.introIndex;
const introWallpaperIndex=startup.introWallpaperIndex;
let viewerPrepared=false,viewerPreparing=false,stagedIntroWallpaper=false,overlayOpen=false;
function syncOverlay(){
 const next=Boolean(document.querySelector('dialog[open], #Details-menu-drawer-container[open], cart-drawer.active'));
 if(next===overlayOpen)return;overlayOpen=next;
 if(next){stopIdleTick();if(frame)cancelAnimationFrame(frame);frame=0;previousRender=0;setInteraction('viewer-render',false)}else refresh();
}
for(const element of document.querySelectorAll('dialog,#Details-menu-drawer-container,cart-drawer'))new MutationObserver(syncOverlay).observe(element,{attributes:true,attributeFilter:['open','class']});
viewer.style.touchAction='auto';
function refresh(){stopIdleTick();if(!frame&&ready&&!overlayOpen&&(visible||!introFinished)&&!document.hidden)frame=requestAnimationFrame(render)}
function finishIntro(){
 if(introFinished)return;
 introHandAbort?.abort();introHand?.dispose();introHand=null;introHandMounted=false;introHandLead=0;introHeader?.stop();
 introFinished=true;introOffset=introPitch=0;updateFraming();viewer.style.touchAction='pan-y';
 document.body.dataset.sclReady='true';document.dispatchEvent(new CustomEvent('shejtano:viewer-ready'));
 phone.holdPaint(false);setInteraction('viewer-intro',false);
 if(stagedIntroWallpaper){phone.startStagedArtwork();stagedIntroWallpaper=false}
 mesh.material[0].userData.artworkReveal.value=1;
 mesh.material[0].userData.introArtwork.value=null;
 introTexture?.dispose();introTexture=null;
 if(pendingWallpaperImage){phone.setArtwork(pendingWallpaperImage,{fadeDuration:reduced?0:650});pendingWallpaperImage=null}
 const artwork=queuedArtwork,device=queuedDevice;queuedArtwork=null;queuedDevice=null;
 shopifyCart?.setModelLoading(false);
 scheduleNearbyArtworks();
 if(artwork!==null)choose(artwork);
 if(device!==null)selectDevice(device);
 if(queuedConfiguration){const configuration=queuedConfiguration;queuedConfiguration=null;applyFavorite(configuration)}
 syncScreenDesign();
 refresh();
}
function revealPhone(){if(!realPhone||!textures[selected]||!introReady)return;
 if(!viewerPrepared){
  if(!viewerPreparing){
   viewerPreparing=true;
   setInteraction('viewer-intro',!introFinished);
   if(introTexture){renderer.initTexture(introTexture);mesh.material[0].userData.artworkReveal.value=0}
   if(!introFinished&&pendingWallpaperImage){stagedIntroWallpaper=phone.stageArtwork(pendingWallpaperImage,renderer);pendingWallpaperImage=null}
   if(!introFinished)phone.holdPaint(true);
   const yieldFrame=()=>new Promise(resolve=>requestAnimationFrame(resolve));
   async function prepare(){
    const texturesToWarm=new Set([textures[selected],introTexture,phone.texture].filter(Boolean));
    scene.traverse(object=>{for(const material of [object.material].flat().filter(Boolean))for(const value of Object.values(material))if(value?.isTexture&&!value.isRenderTargetTexture)texturesToWarm.add(value)});
    let yielded=performance.now();
    for(const texture of texturesToWarm){renderer.initTexture(texture);if(performance.now()-yielded>4){await yieldFrame();yielded=performance.now()}}
    phone.prepare(renderer);
    await (renderer.compileAsync?renderer.compileAsync(scene,camera):renderer.compile(scene,camera));
    const group=scene.userData.case,savedY=group.rotation.y;
    try{for(const yaw of [Math.PI,Math.PI/2,savedY]){group.rotation.y=yaw;renderer.render(scene,camera);await yieldFrame()}}finally{group.rotation.y=savedY}
    if(introHand&&!introSkipRequested){
     introHand.tick(1000);introHandMounted=true;
     try{
      await (renderer.compileAsync?renderer.compileAsync(scene,camera):renderer.compile(scene,camera));
      renderer.render(scene,camera);await yieldFrame();
     }finally{if(introHand)introHand.tick(0)}
    }
    const gl=renderer.getContext();
    if(gl.fenceSync){
     const fence=gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE,0);gl.flush();
     if(fence){const until=performance.now()+600;let status=gl.TIMEOUT_EXPIRED;
      while(status===gl.TIMEOUT_EXPIRED&&performance.now()<until){await yieldFrame();status=gl.clientWaitSync(fence,0,0)}gl.deleteSync(fence);
     }
    }
   }
   prepare().catch(error=>console.warn('Viewer warm-up unavailable',error)).finally(()=>{viewerPrepared=true;requestAnimationFrame(revealPhone)});
  }
  return;
 }
 if(!introReady)return;
 if(introTexture)renderer.initTexture(introTexture);
 renderer.initTexture(phone.texture);
 if(!introScheduled&&introHand&&!introSkipRequested){updateFraming();introHandMounted=true;introHeader.start();introHand.fitEntrance(camera);setViewerQuality(true);}
 ready=true;if(introSkipRequested&&!introFinished)finishIntro();
 renderer.render(scene,camera);viewer.classList.add('ready');status.textContent='';
 if(introFinished&&document.body.dataset.sclReady!=='true'){document.body.dataset.sclReady='true';document.dispatchEvent(new CustomEvent('shejtano:viewer-ready'))}
 syncScreenDesign();
 if(!introScheduled){
  introScheduled=true;introElapsed=0;
  if(!introFinished){
   try{localStorage.setItem('shejtano-intro-artwork',String(introIndex));localStorage.setItem('shejtano-intro-wallpaper',String(introWallpaperIndex))}catch{}
   mesh.material[0].userData.artworkReveal.value=introTexture?0:1;
  }
 }
 refresh();
}

function applyArtwork(texture,{refine=false}={}){
 renderer.initTexture(texture);
 artworkTransition.set(texture,{animate:ready&&introFinished&&!reduced,preserveReveal:!introFinished,refine,duration:refine?360:fastSelection?80:150});fitTextures();releaseRetiredTextures();
 revealPhone();refresh();
}

function choose(index,{keepWallpaper=false}={}){
 if(!introFinished){queuedArtwork=index;return}
 if(index===selected)return;
 const now=performance.now();fastSelection=lastSelectionTime>0&&now-lastSelectionTime<240;lastSelectionTime=now;
 const previous=selected;selected=index;publishConfiguration();artworkTransition?.select(index);cancelArtworkLoads(index);shopifyCart?.selectionChanged();
 artworkButtons[previous].forEach(b=>b.setAttribute('aria-pressed','false'));
 artworkButtons[index].forEach(b=>b.setAttribute('aria-pressed','true'));
 $('#skinCount').textContent=String(galleryOrder.indexOf(index)+1).padStart(2,'0')+' / '+String(names.length).padStart(2,'0');
 viewer.setAttribute('aria-label',t('selected_artwork',{name:names[index]}));
 const cached=showArtworkPreview(index);
 clearTimeout(selectionLoadTimer);
 selectionLoadTimer=setTimeout(()=>{if(selected===index)loadArtwork(index)},cached?100:32);
 clearTimeout(wallpaperTimer);
 if(!keepWallpaper)wallpaperTimer=setTimeout(()=>{if(selected===index)wallpaper?.select(currentDevice.id+':'+index,index)},200);
 syncScreenDesign();
 scheduleNearbyArtworks();
}
galleryOrder.forEach((i,position)=>{const name=names[i],b=document.createElement('button');b.className='skin';b.dataset.artworkIndex=String(i);b.setAttribute('aria-label',t('select_artwork',{name}));b.setAttribute('aria-pressed',String(i===selected));b.innerHTML=`<img crossorigin="anonymous" data-src="${artworkUrl(i,256)}" decoding="async" alt="${t('artwork',{name})}" width="104" height="132" ${position>4?'loading="lazy"':''}><span>${name}</span>`;b.onclick=()=>choose(i);artworkButtons[i].push(b);$('#skinList').append(b)});
createGalleryImages($('#skinList'),{onImage:(index,image)=>{
 const preview=new Image();preview.crossOrigin='anonymous';preview.decoding='async';preview.width=image.naturalWidth;preview.height=image.naturalHeight;preview.src=image.currentSrc||image.src;
 preview.decode().then(()=>{thumbnailImages.set(index,preview);thumbnailReady(index,preview)}).catch(()=>{});
}}); 
createArtworkSearch({names,onSelect:index=>{gallery.center(galleryOrder.indexOf(index),false);choose(index)}});
const gallery=createArtworkGallery($('#skinList'),position=>choose(galleryOrder[position]),reduced,galleryOrder.indexOf(selected));
createUIEffects(document.querySelector('.case-lab-section'));
const albumGrid=$('#albumGrid');
galleryOrder.forEach((index,position)=>{const name=names[index],card=document.createElement('button');card.type='button';card.className='album-card';card.dataset.artworkIndex=String(index);card.setAttribute('aria-label',t('select_artwork',{name}));card.setAttribute('aria-pressed',String(index===selected));card.innerHTML=`<img data-src="${artworkUrl(index,320)}" alt="${t('artwork',{name})}" width="104" height="132" loading="lazy">`;card.onclick=()=>{gallery.center(position,false);choose(index);requestAnimationFrame(()=>$('#skins').scrollIntoView({behavior:reduced?'instant':'smooth',block:'end'}))};artworkButtons[index].push(card);albumGrid.append(card)});
const albumCards=[...albumGrid.children];
observeArtworkImages(albumGrid);
let albumColumns=0;
function layoutAlbum(){
 const width=albumGrid.clientWidth;if(!width)return;
 const columns=width>=760?10:5;
 if(columns===albumColumns)return;albumColumns=columns;
 const rows=Math.ceil(albumCards.length/columns);
 const fragment=document.createDocumentFragment();let cursor=0;
 for(let r=0;r<rows;r++){
  const count=Math.min(columns,albumCards.length-cursor),row=document.createElement('div');
  row.className='album-row';row.style.gridTemplateColumns=`repeat(${columns},minmax(0,1fr))`;
  for(let c=0;c<count;c++)row.append(albumCards[cursor++]);
  fragment.append(row);
 }
 albumGrid.replaceChildren(fragment);
 if($('#artworkAlbum').open)animateArchive($('#artworkAlbum'),albumCards,true,reduced);
}
new ResizeObserver(layoutAlbum).observe(albumGrid);
$('#albumCount').textContent=t('artworks_count',{count:String(names.length).padStart(3,'0')});
$('#artworkAlbum').addEventListener('toggle',()=>{const open=$('#artworkAlbum').open;if(open)layoutAlbum();animateArchive($('#artworkAlbum'),albumCards,open,reduced)});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&$('#artworkAlbum').open){$('#artworkAlbum').open=false;$('#artworkAlbum summary').focus()}});
function renderFinishes(){
 const list=finishesFor(currentDevice);if(!list.some(f=>f.id===phoneFinish))phoneFinish=list[0].id;
 $('#phoneColors').replaceChildren();$('#phoneFinishName').textContent=list.find(f=>f.id===phoneFinish).label;
 list.forEach(f=>{const b=document.createElement('button');b.type='button';b.className='phone-color';b.style.setProperty('--swatch',f.swatch);b.dataset.finish=f.id;b.setAttribute('aria-label',f.label);b.setAttribute('aria-pressed',String(f.id===phoneFinish));const sample='data:image/svg+xml,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><rect width="64" height="64" fill="'+f.swatch+'"/></svg>');b.innerHTML='<span aria-hidden="true"><img src="'+sample+'" alt="" draggable="false"></span><small>'+(f.shortLabel||f.label.replace(' Titanium',''))+'</small>';b.onclick=()=>{phoneFinish=f.id;document.querySelectorAll('.phone-color').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.finish===f.id)));$('#phoneFinishName').textContent=f.label;realPhone?.userData.setFinish(f.id);publishConfiguration();refresh()};$('#phoneColors').append(b)});
}
renderFinishes();
publishConfiguration();
$('#phoneSelect').replaceChildren();DEVICES.forEach(d=>{const option=document.createElement('option');option.value=d.id;option.textContent=d.name;option.selected=d.id===currentDevice.id;$('#phoneSelect').append(option)});$('#phoneSelect').disabled=true;
$('#phoneSelect').onchange=e=>selectDevice?.(e.target.value);
const phonePicker=(()=>{
 const select=$('#phoneSelect'),picker=document.querySelector('[data-phone-picker]'),trigger=picker.querySelector('summary'),options=picker.querySelector('.phone-picker-options');
 picker.className='phone-picker';trigger.className='phone-picker-trigger';options.className='phone-picker-options';
 trigger.setAttribute('aria-label',select.getAttribute('aria-label'));options.setAttribute('role','group');options.setAttribute('aria-label',select.getAttribute('aria-label'));
 const buttons=[...select.options].map(option=>{
  const button=document.createElement('button');button.type='button';button.textContent=option.textContent;button.dataset.value=option.value;
  button.onclick=()=>{if(select.disabled)return;select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));picker.open=false;trigger.focus()};
  button.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&!select.disabled)requestModelPrefetch(option.value)});
  button.addEventListener('focus',()=>{if(!select.disabled)requestModelPrefetch(option.value)});
  options.append(button);return button;
 });
 function sync(){
  trigger.textContent=select.selectedOptions[0]?.textContent||'';trigger.setAttribute('aria-disabled',String(select.disabled));
  for(const button of buttons){button.disabled=select.disabled;button.setAttribute('aria-pressed',String(button.dataset.value===select.value))}
  if(select.disabled)picker.open=false;
 }
 picker.append(trigger,options);select.after(picker);select.hidden=true;select.setAttribute('aria-hidden','true');select.tabIndex=-1;
 trigger.addEventListener('click',event=>{if(select.disabled)event.preventDefault()});
 select.addEventListener('change',sync);
 picker.addEventListener('toggle',()=>{
  if(!picker.open){clearTimeout(modelPrefetchTimer);return}
  const index=DEVICES.findIndex(d=>d.id===select.value);
  const nearby=[DEVICES[index+1],DEVICES[index-1]].find(d=>d&&!d.android&&!deviceCache.has(d.id));
  if(nearby)requestModelPrefetch(nearby.id);
 });
 new MutationObserver(sync).observe(select,{attributes:true,attributeFilter:['disabled'],childList:true});
 document.addEventListener('click',event=>{if(!picker.contains(event.target))picker.open=false});
 picker.addEventListener('keydown',event=>{
  if(event.key==='Escape'){picker.open=false;trigger.focus();event.preventDefault();return}
  if(!picker.open)return;
  const index=buttons.indexOf(document.activeElement),last=buttons.length-1;
  const next={ArrowDown:Math.min(last,index+1),ArrowUp:Math.max(0,index-1),Home:0,End:last}[event.key];
  if(next!==undefined){event.preventDefault();buttons[next]?.focus()}
 });
 sync();return {sync};
})();

function fitTextures(){
 const entry=deviceCache.get(currentDevice.id),printWidth=entry?.shell.userData.printWidth||PRINT_WIDTH,printHeight=entry?.shell.userData.printHeight||PRINT_HEIGHT;
 const bodyHeight=currentDevice.id===DEFAULT_DEVICE.id?4.95:shellSpec(currentDevice).h;
 const placement={printWidth,printHeight,bodyHeight,printBounds:entry?.shell.userData.printBounds};
 textures.forEach((t,index)=>{if(t)fitArtworkTexture(t,index,placement)});
 artworkTransition?.retained().forEach(texture=>fitArtworkTexture(texture,texture.userData.artworkIndex,placement));
 artworkTransition?.updateSourceMatrix();
 if(introTexture){fitArtworkTexture(introTexture,introIndex,placement);introTexture.updateMatrix();mesh.material[0].userData.introArtworkMatrix.value.copy(introTexture.matrix)}
}

function roundPath(x,y,w,h,r,Type=THREE.Shape){const s=new Type();s.moveTo(x+r,y);s.lineTo(x+w-r,y);s.quadraticCurveTo(x+w,y,x+w,y+r);s.lineTo(x+w,y+h-r);s.quadraticCurveTo(x+w,y+h,x+w-r,y+h);s.lineTo(x+r,y+h);s.quadraticCurveTo(x,y+h,x,y+h-r);s.lineTo(x,y+r);s.quadraticCurveTo(x,y,x+r,y);return s}
try{
 renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,powerPreference:'high-performance'});renderer.setPixelRatio(viewerPixelRatio(viewer.clientWidth,viewer.clientHeight,devicePixelRatio));renderer.setClearColor(0x000000,0);renderer.outputColorSpace=THREE.SRGBColorSpace;renderer.toneMapping=THREE.NoToneMapping;renderer.toneMappingExposure=1;viewer.append(renderer.domElement);
 scene=new THREE.Scene();camera=new THREE.PerspectiveCamera(32,1,.1,100);camera.position.set(0,0,10.5);
 scene.add(new THREE.AmbientLight(0xffffff,1.15));
 const key=new THREE.DirectionalLight(0xffffff,.55);key.position.set(-3,4,6);scene.add(key);
 const fill=new THREE.DirectionalLight(0xffffff,.30);fill.position.set(4,-1,4);scene.add(fill);
 const backFill=new THREE.DirectionalLight(0xffffff,.25);backFill.position.set(0,1,-5);scene.add(backFill);
 const print=new THREE.MeshPhysicalMaterial({color:0xffffff,roughness:.16,metalness:0,ior:1.48,clearcoat:1,clearcoatRoughness:.065,specularIntensity:1});
 preserveArtworkColor(print);
 print.userData.artworkReveal.value=1;
 const coatingPixels=new Uint8Array(64*64*4);let coatingSeed=333;for(let i=0;i<64*64;i++){coatingSeed=(1664525*coatingSeed+1013904223)>>>0;const value=225+(coatingSeed%20);coatingPixels.set([value,value,value,255],i*4)}
 const coating=new THREE.DataTexture(coatingPixels,64,64,THREE.RGBAFormat);coating.wrapS=coating.wrapT=THREE.RepeatWrapping;coating.repeat.set(12,24);coating.magFilter=coating.minFilter=THREE.LinearFilter;coating.needsUpdate=true;print.roughnessMap=coating;
 try {
 const studio=new THREE.Scene();studio.background=new THREE.Color(0x29292c);
 function softbox(w,h,x,y,z,intensity){const material=new THREE.MeshBasicMaterial({color:new THREE.Color().setScalar(intensity)});const panel=new THREE.Mesh(new THREE.PlaneGeometry(w,h),material);panel.position.set(x,y,z);panel.lookAt(0,0,0);studio.add(panel)}
 softbox(1.4,6,-4,1,4,2.0);softbox(3.5,5,4,2,1,1.25);softbox(4,2,0,5,-2,.8);
 const pmrem=new THREE.PMREMGenerator(renderer);const reflection=pmrem.fromScene(studio,.06,.1,30);print.envMap=reflection.texture;print.envMapIntensity=.8;
 pmrem.dispose();studio.traverse(o=>{o.geometry?.dispose();o.material?.dispose()});
 }catch(reflectionError){print.envMap=null;console.warn('Studio reflections unavailable; retaining interactive 3D',reflectionError)}
 const innerMaterial=new THREE.MeshStandardMaterial({color:0xbdbcbc,roughness:.9,metalness:0,side:THREE.DoubleSide});
 const group=new THREE.Group();scene.add(group);scene.userData.case=group;
 mesh={material:[print]};
 if(!skipIntro){
  introHandAbort=new AbortController();
  const spec=shellSpec(currentDevice);
  introHandRequest=import('./scl-intro-hand.js?v=2026092515').then(({createIntroHand})=>
   createIntroHand(scene,group,{environment:print.envMap,height:spec.h,width:spec.w,depth:spec.depth,signal:introHandAbort.signal,deferDisposal:true}));
  introHandRequest.catch(()=>{});
 }
 artworkTransition=createArtworkTransition(print,{duration:150,onRelease:releaseRetiredTextures});
 phone=createScreenWallpaper(undefined,{onChange:()=>{syncScreenDesign();refresh()}});
 let templateRequest;
 function getTemplate(){
  if(!templateRequest)templateRequest=import('./scl-real-phone.js?v=2026092005').then(module=>module.loadRealPhone(print.envMap,phone.texture)).then(model=>{
   phoneTemplate=model.clone(true);
   phoneTemplate.traverse(o=>{if(o.isMesh)o.material=Array.isArray(o.material)?o.material.map(m=>m.clone()):o.material.clone()});
   phoneTemplate.updateWorldMatrix(true,true);
   deviceCache.set(DEFAULT_DEVICE.id,{shell:buildSnapShell(print,innerMaterial),model});
   return phoneTemplate;
  }).catch(error=>{templateRequest=null;throw error});
  return templateRequest;
 }
 const pendingDevices=new Map();
 function pruneAndroidDevices(activeId){
  const recent=deviceCache.get(activeId);deviceCache.delete(activeId);deviceCache.set(activeId,recent);
  const androidEntries=[...deviceCache].filter(([,entry])=>entry.android);
  for(const [id,entry] of androidEntries.slice(0,-4)){
   if(id===activeId)continue;
   deviceCache.delete(id);
   const geometries=new Set(),materials=new Set();
   entry.model.traverse(o=>{if(o.geometry)geometries.add(o.geometry);for(const material of [o.material].flat().filter(Boolean))materials.add(material)});
   entry.shell.traverse(o=>{if(o.geometry)geometries.add(o.geometry)});
   geometries.forEach(g=>g.dispose());materials.forEach(m=>m.dispose());
  }
 }
 function prepareDevice(d){
  clearTimeout(modelPrefetchTimer);
  if(deviceCache.has(d.id)){cancelModelPrefetch();return Promise.resolve(deviceCache.get(d.id))}
  if(pendingDevices.has(d.id))return pendingDevices.get(d.id);
  beginModelSelection(d);
  const request=(async()=>{
   const android=d.android?await import('./scl-android-geometry.js?v=2026092002'):null;
   const model=android?android.buildAndroidPhone(print.envMap,phone.texture,d)
    :d.uploaded?await loadUploadedPhone(print.envMap,phone.texture,d)
    :d.id.startsWith('18-pro')?await (await import('./scl-iphone18pro.js?v=2026092102')).loadIphone18Pro(print.envMap,phone.texture,d,getTemplate())
    :d.id.startsWith('17-pro')?await (await import('./scl-iphone17pro.js?v=2026092005')).loadIphone17Pro(print.envMap,phone.texture,d,getTemplate())
    :d.id.startsWith('16-pro')?await (await import('./scl-iphone16pro.js?v=2026092005')).loadIphone16Pro(print.envMap,phone.texture,d)
    :d.id.startsWith('16')?await (await import('./scl-iphone16.js?v=2026092005')).loadIphone16(print.envMap,phone.texture,d)
    :(await import('./scl-phone-variants.js?v=2026091301')).buildPhoneVariant(d,await getTemplate(),print.envMap,phone.texture);
   phone.bind(model);
   const entry=deviceCache.get(d.id)||{shell:android?android.buildAndroidCase(print,innerMaterial,d):buildSnapShell(print,innerMaterial,d),model,android:!!android};
   deviceCache.set(d.id,entry);return entry;
  })().finally(()=>pendingDevices.delete(d.id));
  pendingDevices.set(d.id,request);return request;
 }
 let deviceRequest=0;
 selectDevice=async (id,initial=false)=>{
  if(!initial&&!introFinished){queuedDevice=id;return}
  configurationLoading=true;publishConfiguration();
  shopifyCart?.setModelLoading(true);
  const request=++deviceRequest,d=deviceById(id);let entry;
  try{
   if(!deviceCache.has(d.id))status.textContent=t('loading_model',{model:d.name});
   entry=await prepareDevice(d);
  }catch(error){if(request===deviceRequest){status.textContent=t('model_failed',{model:d.name});$('#phoneSelect').value=currentDevice.id;phonePicker.sync();configurationLoading=false;publishConfiguration();shopifyCart?.setModelLoading(false)}console.warn(error);return}
  if(request!==deviceRequest)return;
  status.textContent=ready?'':t('loading_device');
  phone.bind(entry.model);
  group.clear();group.add(entry.shell,entry.model);currentDevice=d;shopifyCart?.selectionChanged();shopifyCart?.setModelLoading(!introFinished);realPhone=entry.model;updateFraming();phone.setAspect(d.screen[0]/d.screen[1]);if(ready)wallpaper?.select(d.id+':'+selected,selected);renderFinishes();realPhone.userData.setFinish(phoneFinish);fitTextures();revealPhone();refresh();
  configurationLoading=false;publishConfiguration();
  pruneAndroidDevices(d.id);
  return true;
 };
 $('#phoneSelect').disabled=false;
 selectDevice(currentDevice.id,true);
 const pendingArtworks=new Map(),recentArtworks=new Map();
 let openingTextureUsed=false,nearbyTimer=0,nearbyGeneration=0,detailTexture=null,detailArtwork;
 const fetchArtworkBytes=createArtworkDownloads(index=>artworkUrl(index,1024),fetch,6);
 const fetchWallpaperBytes=createArtworkDownloads(index=>artworkUrl(index,512),fetch,4);
 cancelArtworkLoads=index=>{
  clearTimeout(nearbyTimer);nearbyGeneration++;
  detailArtwork?.select(index);
  if(detailTexture&&detailTexture.userData.artworkIndex!==index){retiredTextures.add(detailTexture);detailTexture=null;releaseRetiredTextures()}
  fetchArtworkBytes.cancelExcept([index]);
  for(const key of pendingArtworks.keys())if(key!==index)pendingArtworks.delete(key);
 };
 function storeTexture(index,texture,width){
  texture.userData.sclWidth=width;texture.userData.artworkIndex=index;
  texture.colorSpace=THREE.SRGBColorSpace;texture.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());
  const previousTexture=textures[index];textures[index]=texture;fitTextures();
  if(index===selected){applyArtwork(texture);status.textContent=ready?'':t('loading_device')}
  if(previousTexture&&previousTexture!==texture)retiredTextures.add(previousTexture);
  const cached=textures.map((t,i)=>t?i:-1).filter(i=>i>=0).sort((a,b)=>(recentArtworks.get(a)||0)-(recentArtworks.get(b)||0));
  while(cached.length>6){
   const victim=cached.findIndex(i=>i!==selected&&!artworkTransition.owns(textures[i]));if(victim<0)break;
   const [i]=cached.splice(victim,1);textures[i].dispose();textures[i]=undefined;recentArtworks.delete(i);
  }
  releaseRetiredTextures();return texture;
 }
 showArtworkPreview=index=>{
  recentArtworks.set(index,performance.now());
  if(textures[index]){applyArtwork(textures[index]);return true}
  const image=thumbnailImages.get(index);
  if(image?.naturalWidth){const texture=new THREE.Texture(image);texture.needsUpdate=true;storeTexture(index,texture,image.naturalWidth);return true}
  return false;
 };
 thumbnailReady=(index,image)=>{if(ready&&introFinished&&index===selected&&!textures[index])showArtworkPreview(index)};
 async function decodeArtwork(index,priority){
  if(index===STARTUP_ARTWORK&&!openingTextureUsed){
   openingTextureUsed=true;const image=await startup.selected;
   if(image){const texture=new THREE.Texture(image);texture.needsUpdate=true;return texture}
  }
  const blob=await fetchArtworkBytes(index,priority);
  const url=URL.createObjectURL(blob),image=new Image();image.decoding='async';
  try{image.src=url;await image.decode();const texture=new THREE.Texture(image);texture.needsUpdate=true;return texture}
  finally{URL.revokeObjectURL(url)}
 }
 loadArtwork=(index,priority='high')=>{
  if(index<0||index>=names.length)return Promise.resolve();
  recentArtworks.set(index,performance.now());
  if(textures[index]?.userData.sclWidth>=1024)return Promise.resolve(textures[index]);
  if(pendingArtworks.has(index))return pendingArtworks.get(index);
  const generation=nearbyGeneration;
  const request=decodeArtwork(index,priority).then(texture=>{
   if(!texture)return;
   if(index!==selected&&(priority==='high'||generation!==nearbyGeneration)){texture.dispose();return}
   if(textures[index]?.userData.sclWidth>=1024){texture.dispose();return textures[index]}
   const stored=storeTexture(index,texture,1024);
   if(priority==='low'&&document.body.dataset.sclInteracting!=='true')renderer.initTexture(stored);
   return stored;
  }).catch(error=>{
   if(error.name==='AbortError')return;
   if(index===selected&&!textures[index])status.textContent=t('artwork_failed');console.warn(error);
  }).finally(()=>{if(pendingArtworks.get(index)===request)pendingArtworks.delete(index)});
  pendingArtworks.set(index,request);return request;
 };
 detailArtwork=createArtworkDetail({
  enabled:()=>!navigator.connection?.saveData&&!/^(slow-)?2g$/.test(navigator.connection?.effectiveType||''),
  canLoad:index=>index===selected&&ready&&introFinished&&visible&&!document.hidden&&!overlayOpen&&!configurationLoading&&textures[index]?.userData.sclWidth>=1024,
  canApply:index=>index===selected&&ready&&visible&&!document.hidden&&!overlayOpen&&!configurationLoading&&document.body.dataset.sclInteracting!=='true',
  load:async(index,signal)=>{
   const base=textures[index].image,aspect=(base.naturalHeight||base.height)/(base.naturalWidth||base.width);
   const width=Math.min(2048,Math.floor(renderer.capabilities.maxTextureSize/Math.max(1,aspect)));
   if(width<=1024)return null;
   const response=await fetch(artworkUrl(index,width),{priority:'low',signal});
   if(!response.ok)throw new Error('Detail artwork unavailable');
   const blob=await response.blob();if(signal.aborted)return null;
   const url=URL.createObjectURL(blob),image=new Image();image.decoding='async';
   try{
    image.src=url;await image.decode();if(signal.aborted)return null;
    const texture=new THREE.Texture(image);texture.needsUpdate=true;
    texture.userData.sclWidth=image.naturalWidth;texture.userData.artworkIndex=index;
    texture.colorSpace=THREE.SRGBColorSpace;texture.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());
    return texture;
   }finally{URL.revokeObjectURL(url)}
  },
  apply:(index,texture)=>{
   if(index!==selected){texture.dispose();return}
   if(detailTexture)retiredTextures.add(detailTexture);
   detailTexture=texture;applyArtwork(texture,{refine:true});
  },
  release:texture=>texture.dispose()
 });
 detailArtwork.select(selected);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)detailArtwork.pause();else detailArtwork.resume()});
 window.addEventListener('pagehide',()=>detailArtwork.pause());
 window.addEventListener('pageshow',()=>detailArtwork.resume());
 scheduleNearbyArtworks=()=>{
  clearTimeout(nearbyTimer);const generation=++nearbyGeneration,origin=selected;
  const connection=navigator.connection;
  if(!introFinished||connection?.saveData||/^(slow-)?2g$/.test(connection?.effectiveType||''))return;
  nearbyTimer=setTimeout(async()=>{
   await loadArtwork(origin);
   const position=galleryOrder.indexOf(origin),next=galleryOrder[position+1],previous=galleryOrder[position-1];
   for(const index of [next,previous]){
    if(generation!==nearbyGeneration||selected!==origin||!Number.isInteger(index))continue;
    await loadArtwork(index,'low');
   }
  },300);
 };
 wallpaper=createRandomWallpaper({count:names.length,initialIndex:STARTUP_WALLPAPER,deferInitial:false,loadImage:async index=>{
  if(index===STARTUP_WALLPAPER&&!introScheduled){const image=await startup.finalScreen;if(image)return image}
  if(textures[index])return textures[index].image;
  fetchWallpaperBytes.cancelExcept([index]);
  const blob=await fetchWallpaperBytes(index,'low'),url=URL.createObjectURL(blob),image=new Image();
  try{image.src=url;await image.decode();return image}finally{URL.revokeObjectURL(url)}
 },onImage:(image,index)=>{wallpaperIndices.set(image,index);configurationWallpaper=index;if(!introFinished)pendingWallpaperImage=image;else phone.setArtwork(image,{fadeDuration:reduced?0:(fastSelection?100:180)});syncScreenDesign();publishConfiguration();revealPhone();refresh()},onError:error=>{if(error.name==='AbortError')return;revealPhone();console.warn('Wallpaper could not load; retaining the previous image',error)}});
 loadArtwork(selected).then(()=>{if(skipIntro)scheduleNearbyArtworks()});
 wallpaper.select(currentDevice.id+':'+selected,selected);

 async function prepareIntro(){
  if(skipIntro)return;
  const [cover,selectedImage,hand]=await Promise.all([boundedIntroAsset(startup.cover,1800),startup.selected,boundedIntroAsset(introHandRequest,1800)]);
  if(hand&&!introSkipRequested&&!motionPreference.matches){introHand=hand;introHandLead=hand.spinStart}else{hand?.dispose();introHandAbort?.abort()}
  if(cover){introTexture=new THREE.Texture(cover);introTexture.needsUpdate=true}
  if(!introTexture){
   const cached=[...document.querySelectorAll('.skin')].find(card=>Number(card.dataset.artworkIndex)!==STARTUP_ARTWORK&&card.querySelector('img')?.naturalWidth>=768);
   if(cached){introIndex=Number(cached.dataset.artworkIndex);introTexture=new THREE.Texture(cached.querySelector('img'));introTexture.needsUpdate=true}
  }
  if(introTexture){introTexture.colorSpace=THREE.SRGBColorSpace;introTexture.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());fitTextures();print.userData.introArtwork.value=introTexture}
  const initialScreen=startup.screenImage||(introTexture?selectedImage:pendingWallpaperImage);
  if(initialScreen){
   if(initialScreen===startup.screenImage)wallpaperIndices.set(initialScreen,introWallpaperIndex);
   else if(initialScreen===selectedImage)wallpaperIndices.set(initialScreen,STARTUP_ARTWORK);
   phone.setArtwork(initialScreen);
  }
  introReady=true;revealPhone();
 }
 prepareIntro();
 updateFraming=()=>{if(characterView?.active){characterView.fit(shellSpec(currentDevice).h);const aspect=Math.max(.3,viewer.clientWidth/viewer.clientHeight);baseDistance=Math.max(11,7/aspect);camera.position.z=baseDistance/currentZoom;characterView.frame(2*Math.tan(THREE.MathUtils.degToRad(camera.fov/2))*baseDistance,aspect,matchMedia('(max-width: 759px)').matches);refresh();return}const mobile=matchMedia('(max-width: 759px)').matches,height=Math.max(100,viewer.clientHeight),space=height/(height-32),previousAspect=viewer.clientWidth/(height-32);scene.userData.case.position.y=mobile?-.07:0;const preferred=(mobile?9.6:(previousAspect<.78?11.4:9.75))*phoneFramingRatio(currentDevice)*space;baseDistance=rotationSafeDistance(preferred,shellSpec(currentDevice),mobile?-.07:0,camera.fov);camera.position.z=baseDistance/currentZoom;refresh()};
 introHeader=createIntroHeader(viewer,renderer,camera,{onChange:()=>{setViewerQuality(true);refresh()}});
 let viewerWidth=1,viewerHeight=1,appliedRatio=0;
 const desiredPixelRatio=(width,height,busy=false)=>characterView?.active?characterPixelRatio(width,height,devicePixelRatio,characterView.mobileProfile):viewerPixelRatio(width,height+(introHeader?.padding||0),devicePixelRatio,busy);
 setViewerQuality=busy=>{if(characterView?.active)characterView.setQuality({interacting:busy});const ratio=desiredPixelRatio(viewerWidth,viewerHeight,busy);if(Math.abs(ratio-appliedRatio)>.02){appliedRatio=ratio;renderer.setPixelRatio(ratio)}};
 const resize=()=>{
  const width=viewer.clientWidth,height=viewer.clientHeight;
  if(width<1||height<1)return;
  const ratio=desiredPixelRatio(width,height);
  if(width===viewerWidth&&height===viewerHeight&&Math.abs(ratio-appliedRatio)<=.02)return;
  viewerWidth=width;viewerHeight=height;
  setViewerQuality(!introFinished||pose.dragging);
  renderer.setSize(width,height,false);camera.aspect=width/height;
  updateFraming();camera.updateProjectionMatrix();introHeader?.resize();setViewerQuality(!introFinished||pose.dragging);
  if(ready&&!document.hidden)renderer.render(scene,camera);
  refresh();
 };
 observeViewerSize(viewer,resize);
 renderer.domElement.addEventListener('webglcontextlost',e=>{e.preventDefault();introHeader?.stop();ready=false;viewer.classList.remove('ready');status.textContent=t('paused_3d')});
 gestures=createViewerGestures(viewer,pose,refresh,()=>ready&&introFinished&&!characterLoading,()=>characterView?.active?{minZoom:.9,maxZoom:2.6,maxPitch:.21}:{});
 new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;if(visible||!introFinished)refresh();else if(frame){cancelAnimationFrame(frame);frame=0;previousRender=0;setInteraction('viewer-render',false)}},{threshold:.05}).observe(viewer);document.addEventListener('visibilitychange',()=>{if(document.hidden&&frame){cancelAnimationFrame(frame);frame=0;previousRender=0}else{refresh()}});

}catch(error){console.error(error);status.textContent=t('unavailable_3d');$('#rotate').disabled=true;$('#reset').disabled=true;document.body.dataset.sclFailed='true';document.dispatchEvent(new CustomEvent('shejtano:viewer-failed'));}
let previousRender=0;
document.addEventListener('shejtano:boot-reveal',()=>{previousRender=0;refresh()});
function render(time){frame=0;if(!ready||overlayOpen||(!visible&&introFinished)||document.hidden)return;
 const elapsed=previousRender?Math.min(120,time-previousRender):16.67,dt=Math.min(50,elapsed);previousRender=time;
 const smoothing=motionSmoothing(dt,pose.dragging,reduced);
 if(turntable.running){
  currentY=turntable.advance(dt);pose.yaw=currentY;
 }else currentY+=(pose.yaw-currentY)*smoothing;
 currentX+=(pose.pitch-currentX)*smoothing;currentZoom+=(pose.zoom-currentZoom)*smoothing;
 const bootWaiting=['loading','background'].includes(document.documentElement.dataset.shejBoot);
 if(!introFinished&&!bootWaiting)introElapsed+=elapsed;
 let handMoving=false;
 if(!introFinished&&introHand){
  handMoving=introHand.tick(Math.max(0,introElapsed-120));
  if(!handMoving)introHandMounted=false;
 }
 const introProgress=Math.max(0,Math.min(1,(introElapsed-120-introHandLead)/INTRO_DURATION));
 const introMoving=!introFinished;
 const motion=sampleIntro(introMoving?introProgress:1);
 introOffset=introMoving?motion.yaw:0;introPitch=introMoving?motion.pitch:0;
 if(introMoving)mesh.material[0].userData.artworkReveal.value=introTexture?motion.reveal:1;
 if(stagedIntroWallpaper&&introProgress>=.52){phone.startStagedArtwork();stagedIntroWallpaper=false}
 if(introMoving&&introProgress>=1)finishIntro();
 if(characterView?.active)characterView.pose(currentY,currentX);
 else if(!handMoving||introElapsed-120>=introHandLead)scene.userData.case.rotation.set(currentX+introPitch,currentY+introOffset,0);
 camera.position.z=baseDistance/currentZoom;
 const moving=turntable.running||pose.dragging||Math.abs(pose.yaw-currentY)>.0002||Math.abs(pose.pitch-currentX)>.0002||Math.abs(pose.zoom-currentZoom)>.0002;
 const idleMoving=characterView?.active&&!motionPreference.matches&&!moving&&!introMoving;
 if(idleMoving)characterView.advanceIdle(Math.min(elapsed,1000/30)/1000);
 const screenMoving=phone.advanceTransition(dt);
 syncScreenDesign();
 const artworkMoving=introFinished&&artworkTransition.advance(dt);
 setInteraction('viewer-render',moving||introMoving||screenMoving||artworkMoving);
 setViewerQuality(moving||introMoving);
 renderer.render(scene,camera);
 if(document.body.dataset.sclPainted!=='true'){document.body.dataset.sclPainted='true';document.dispatchEvent(new CustomEvent('shejtano:viewer-painted'))}
 if(bootWaiting){previousRender=0;return}
 if(moving||introMoving||screenMoving||artworkMoving)refresh();
 else if(idleMoving)characterIdleTimer=setTimeout(refresh,Math.max(0,1000/30-(performance.now()-time)));
 else previousRender=0}
$('#rotate').onclick=()=>{
 if(turntable.running){stopTurntable();return}
 if(!introFinished||!ready||pose.dragging)return;
 turntable.start(currentY);pose.yaw=currentY;
 syncRotationControl();refresh();
};
$('#useWallpaper').onclick=()=>{
 const index=wallpaperIndices.get(phone?.getArtwork());
 if(!ready||!introFinished||!Number.isInteger(index)||index===selected)return;
 choose(index,{keepWallpaper:true});gallery.center(galleryOrder.indexOf(index),false);
};
syncRotationControl();syncScreenDesign();
$('#reset').onclick=()=>{if(introFinished){stopTurntable();characterView?.resetIdle();gestures?.reset();updateFraming()}};
viewer.addEventListener('pointerdown',stopTurntable,{capture:true,passive:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden){clearTimeout(modelPrefetchTimer);cancelModelPrefetch()}});
shopifyCart=createShopifyCart(()=>({index:selected,device:currentDevice}));
if(!introFinished)shopifyCart.setModelLoading(true);
const protectedVisual='img,canvas,#viewer,.skin,.album-card,.search-match,.artwork-hold-preview';
document.addEventListener('contextmenu',event=>{if(event.target.closest?.(protectedVisual))event.preventDefault()});
document.addEventListener('dragstart',event=>{if(event.target.closest?.(protectedVisual))event.preventDefault()});
document.addEventListener('selectstart',event=>{if(event.target.closest?.('#viewer,.skin-list,.album-pages'))event.preventDefault()});
document.querySelectorAll('img').forEach(img=>{img.draggable=false});

async function applyFavorite(configuration){
 const request=++configurationRequest;
 if(!introFinished){queuedConfiguration=configuration;return}
 if(configuration.model!==currentDevice.id||configurationLoading){
  if(!selectDevice||!await selectDevice(configuration.model)||request!==configurationRequest)return;
 }
 phoneFinish=configuration.finish;
 renderFinishes();realPhone?.userData.setFinish(phoneFinish);
 $('#phoneSelect').value=currentDevice.id;phonePicker.sync();
 const index=names.indexOf(configuration.artwork);
 choose(index);gallery.center(galleryOrder.indexOf(index),false);
 publishConfiguration();refresh();
}
document.addEventListener('shejtano:configuration-apply',event=>{
 const configuration=event.detail;
 const device=configuration&&DEVICES.find(entry=>entry.id===configuration.model);
 if(!selectDevice||!device||!names.includes(configuration.artwork)||!finishesFor(device).some(finish=>finish.id===configuration.finish))return;
 event.preventDefault();applyFavorite(configuration);
});

function getCharacterModule(){
 if(!characterModuleRequest)characterModuleRequest=import('./scl-character-view.js?v=2026092518').catch(error=>{characterModuleRequest=null;throw error});
 return characterModuleRequest;
}
function prepareCharacter(){
 if(characterView)return Promise.resolve(characterView);
 if(!characterViewRequest){
  const progress=value=>{if(characterLoading)status.textContent=$('#characterView').dataset.loading+' '+Math.min(99,Math.round(value*100))+'%'};
  characterViewRequest=getCharacterModule()
   .then(module=>module.createCharacterView(scene,scene.userData.case,progress,mesh.material[0].envMap))
   .then(async view=>{await view.prepare(renderer,camera).catch(error=>console.warn('Character shader warm-up unavailable',error));characterView=view;return view})
   .catch(error=>{characterViewRequest=null;throw error});
 }
 return characterViewRequest;
}
const characterButton=$('#characterView');
if(characterButton){
 characterButton.onclick=async()=>{
  if(!ready||!introFinished||characterLoading)return;
  if(characterView?.active){
   stopTurntable();gestures?.reset();characterView.hide();characterButton.setAttribute('aria-pressed','false');viewer.classList.remove('character-active');
   $('#rotate').disabled=false;$('#reset').disabled=false;updateFraming();refresh();return;
  }
  characterLoading=true;characterButton.disabled=true;characterButton.setAttribute('aria-busy','true');status.textContent=characterButton.dataset.loading;
  try{
   characterView=await prepareCharacter();
   stopTurntable();gestures?.reset();pose.yaw=pose.pitch=currentX=currentY=0;pose.zoom=currentZoom=1;
   characterView.show(shellSpec(currentDevice).h);characterView.pose(0,0);viewer.classList.add('character-active');
   characterButton.setAttribute('aria-pressed','true');$('#rotate').disabled=false;$('#reset').disabled=false;status.textContent='';updateFraming();refresh();
  }catch(error){status.textContent=characterButton.dataset.error;console.warn('Character view unavailable',error)}
  finally{characterLoading=false;characterButton.disabled=false;characterButton.removeAttribute('aria-busy')}
 };
}
